import {Component, OnInit, Input} from '@angular/core';
import {faCloudDownloadAlt} from '@fortawesome/free-solid-svg-icons';
import {DeviceService} from '../../../services/device/device.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import saveAs from 'file-saver';
import {Device} from '../../../classes/device/device';

@Component({
  selector: 'app-device-configuration-download',
  templateUrl: './device-configuration-download.component.html',
  styleUrls: ['./device-configuration-download.component.css']
})
export class DeviceConfigurationDownloadComponent implements OnInit {

  faCloudDownloadAlt = faCloudDownloadAlt;
  @Input('device') device: any;
  showSpinner: boolean = false;
  deviceType: string;
  private blob: Blob;

  constructor(private deviceService: DeviceService,
              private toastr: ToastrService,
              private translate: TranslateService) {
  }

  ngOnInit() {

  }

  isAvalaible() {

    let excludes: any[] = ['gateway_v3', 'spcu_v5'];
    if (typeof this.device.device_type === 'object') {
      this.deviceType = this.device.device_type.type;
      return excludes.includes(this.device.device_type.type) && this.device.project_name !== '-';
    }

    if (typeof this.device.device_type === 'string') {
      this.deviceType = this.device.device_type;
      return excludes.includes(this.device.device_type) && this.device.project_name !== '-';
    }

  }

  download() {
    this.showSpinner = true;
    if (this.deviceType === 'gateway_v3') {
      this.deviceService.getConfigurationForGateway(this.device.uid).subscribe((data: any) => {
          this.blob = new Blob([JSON.stringify(data, undefined, 3)], {type: 'application/json'});

          saveAs(this.blob, this.device.uid + '_configuration.json');
          this.toastr.success(this.translate.instant('SUCCESS_DOWNLOAD_JSON_CONFIG'), this.translate.instant('SUCCESS'));
          this.showSpinner = false;
        },
        error2 => {
          this.toastr.error(this.translate.instant('ERROR_DOWNLOAD_JSON_CONFIG'), this.translate.instant('ERROR'));
          this.showSpinner = false;
        });
    }

    if (this.deviceType === 'spcu_v5') {
      let versions = [5.2, 5.3];
      versions.forEach(version => {
          this.getJsonConfigForSpcu(version);
        }
      );

    }
  }

  private getJsonConfigForSpcu(version: number = 5.2) {
    this.deviceService.getConfigurationForSPCU(this.device.id, version).subscribe((data: any) => {
        this.blob = new Blob([JSON.stringify(data, undefined, 3)], {type: 'application/json'});
        let versionForFileName = version.toString().replace('.', '-');
        saveAs(this.blob, this.device.uid + '_V' + versionForFileName + '_configuration.json');
        this.toastr.success(this.translate.instant('SUCCESS_DOWNLOAD_JSON_CONFIG'), this.translate.instant('SUCCESS'));
        this.showSpinner = false;
      },
      error2 => {
        this.toastr.error(this.translate.instant('ERROR_DOWNLOAD_JSON_CONFIG'), this.translate.instant('ERROR'));
        this.showSpinner = false;
      });
  }
}
